import classNames from 'classnames';
import { useCallback } from 'react';
import { InputNumber, InputNumberProps } from 'antd';

export function InputNumeric({
  className,
  onKeyDown,
  onPaste,
  ...rest
}: InputNumberProps) {

  const handleKeyDown = useCallback((event: React.KeyboardEvent<HTMLInputElement>) => {
    if (!event.ctrlKey || event.altKey || event.metaKey || event.shiftKey) {
      if (event.key.length === 1) {
        if (!/[0-9]/.test(event.key)) {
          event.preventDefault();
        }
      }
    }
    onKeyDown && onKeyDown(event);
  }, [onKeyDown]);

  const handlePaste = useCallback((e: React.ClipboardEvent<HTMLInputElement>) => {
    const text = e.clipboardData.getData('text/plain');
    if (!/^(\d)+$/.test(text)) {
      return e.preventDefault();
    }
    onPaste && onPaste(e);
  }, [onPaste]);

  return (
    <InputNumber
      controls={false}
      onPaste={handlePaste}
      onKeyDown={handleKeyDown}
      className={classNames('w-full', className)}
      {...rest}
    />
  );
}

export default InputNumeric;
